const translations = {
    flightDetails: 'Flight Details',
    saveReport: 'Save Report'
};

export default translations;
